import { Providers } from "./Providers";
import { AppRouter } from "./Router";

export const App = () => {
  return (
    <Providers>
      <AppRouter />
    </Providers>
  );
};
